<template>
  <InertiaLink
    :href="video.videoPageUrl"
    class="tw-h-max hover:tw-text-current"
  >
    <Card has-shadow-hover padding-class="tw-p-0" class="tw-overflow-hidden">
      <div
        class="tw-relative tw-grid tw-aspect-video tw-place-items-center tw-bg-neutral-800"
      >
        <img :src="video.thumbnailUrl" alt="" loading="lazy" />
        <div
          class="tw-absolute tw-grid tw-h-11 tw-w-11 tw-place-items-center tw-rounded-full tw-bg-neutral-800"
        >
          <PlayIcon class="tw-h-10 tw-w-10 tw-text-white" />
        </div>
      </div>
      <div class="tw-space-y-3 tw-p-5">
        <div class="tw-heading-3">{{ video.title }}</div>
        <div class="tw-space-x-2 tw-text-xs tw-text-neutral-500">
          <span>
            {{ formatDate(video.createdAt, 'dd MMMM yyyy') }}
          </span>
          <span>•</span>
          <span>{{ duration }} min</span>
        </div>
        <div class="tw-inline-flex tw-text-xs tw-text-neutral-500">
          <LabelIcon class="tw-mr-2 tw-mt-[1px] tw-h-3.5 tw-w-3.5" />
          {{ tagNames.join(', ') }}
        </div>
        <div class="tw-flex tw-items-center tw-space-x-2">
          <Avatar
            :src="video.author.avatarUrl"
            :alt="`${video.author.displayName}'s avatar`"
            class="tw-shrink-0"
          />
          <div>
            <div class="tw-heading-6">{{ video.author.displayName }}</div>
            <div class="tw-line-clamp-1 tw-text-xs tw-text-neutral-500">
              {{ video.author.professionTitle }}
            </div>
          </div>
        </div>
      </div>
    </Card>
  </InertiaLink>
</template>

<script setup>
import Card from '@/shared/components/Card.vue'
import { formatDuration } from '@/shared/utils/videoDuration.js'
import Avatar from '@/shared/components/avatar/Avatar.vue'
import PlayIcon from '@/assets/images/icons/play.svg'
import LabelIcon from '@/assets/images/icons/label.svg'
import { computed } from 'vue'
import { useDateManager } from '@/shared/composables/useDateManager.js'

const props = defineProps({
  video: {
    type: Object,
    required: true,
  },
})

const { formatDate } = useDateManager()

const duration = computed(() => formatDuration(props.video.duration))
const tagNames = computed(() => props.video.tags.map((tag) => tag.name))
</script>
